import FORM_AUDIENCE_TYPE from '../../../../constants/FormAudienceType';

// AD-2676: a staff trigger form about a child can be triggered by a parent form, a form sent to the
// child's previous school, or an external form.
export const isParentOrExternalSourceForm = (form) => [
    FORM_AUDIENCE_TYPE.parentsForChildCompletion,
    FORM_AUDIENCE_TYPE.previousSchool,
    FORM_AUDIENCE_TYPE.externalUsers
].includes(Number(form?.audience ?? form?.Audience));
